import styled from '@emotion/styled';

export const CardsWrapperStyled = styled.div`
  max-width: 858px;
`;
